import React, { useEffect, useState } from "react";
import { InputLabel } from "@mui/material";
import { fetchCommunityDocName } from "../../Services/Community/CommunityAPI/communityApi";
import {
  getDocTypeApi,
  uploadDocuments,
  getAllDocuments,
  deleteDocumentData,
  fetchDocumentById,
  fetchTaskStatus,
  updateDocumentNameApi
} from "../../Services/DocumentUpload/documentUploadApi";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import "./uploadDocument.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CommunityOwner, SuperAdmin } from "../../Utils/Constant";
import CircularProgress from "@mui/material/CircularProgress";
import { Box } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { capitalizeWords } from "../../Utils/LetterCase";
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import PaginationComponent from "../Pagination/pagination";

const UploadDocument = () => {
  const [fileName, setFileName] = useState("");
  const [documentdata, setDocumentData] = useState([]);
  const [Alldoc, setAllDoc] = useState([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [currentId, setcurrentId] = useState();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    community_id: "",
    doc_type: "",
    doc_type_name: "",
    community_documents: [],
  });
  const [loading, setLoading] = useState(true);
  const { loading: uloading } = useSelector((state) => state.uploadDocuments);
  const [documentWithCommunity, setDocumentWithCommunity] = useState([]);
  const [privatetypeId, setPrivatetypeId] = useState();
  const [publictypeId, setPublictypeId] = useState();
  const [selectedDocType, setSelectedDocType] = useState("");
  const [errors, setErrors] = useState({});
  const { data } = useSelector((state) => state.communityDocName);
  // const { loading } = useSelector((state) => state.getAllDocuments);
  const dispatch = useDispatch();
  const [docTypes, setDocTypes] = useState();

  const location = useLocation();
  const community_id_for_doc = location.state?.communityId;
  const community_name = location.state?.communityName;

  const userType = localStorage.getItem("user_type");
  const userId = localStorage.getItem("user_id");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [disabled, setDisabled] = useState(true);
  const [taskId, setTaskId] = useState();
  const [refetch, setRefetch] = useState(false);
  const { data: taskStatus } = useSelector((state) => state.fetchTaskStatus);
  const [modalShow, setModalShow] = React.useState(false);
  const [fileNameToEdit, setFileNameToEdit] = useState();
  const [documentIdForEdit, setDocumentIdForEdit] = useState()
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [count, setCount] = useState();

  useEffect(() => {
    if (!taskId) return;

    const interval = setInterval(() => {
      dispatch(fetchTaskStatus(taskId));
    }, 3000);

    if (taskStatus?.data?.status === 'completed') {
      toast.success(taskStatus?.message)
      clearInterval(interval);
      setRefetch(true)
    }

    return () => clearInterval(interval);
  }, [dispatch, taskId, taskStatus]);

  useEffect(() => {
    dispatch(fetchCommunityDocName());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getDocTypeApi())
      .unwrap()
      .then((res) => {
        setDocTypes(res.data);
      })
      .catch((err) => {
        toast.error("Failed to fetch document types.");
      });
  }, [dispatch]);

  useEffect(() => {
    dispatch(getAllDocuments({ community_id: community_id_for_doc, page: page, page_size: pageSize, search: search, access: "all", user_id: userId }))
      .unwrap()
      .then((res) => {
        setAllDoc(res?.data);
        setLoading(false);
        setCount(res?.data?.count)
      })
      .catch((err) => {
        toast.error("Failed to fetch document.");
      });
  }, [dispatch, documentdata, refetch, page, pageSize, search]);

  useEffect(() => {
    if (Alldoc?.data) {
      const documentWithCommunity = Alldoc?.data?.filter(
        (data) => data.community_id === community_id_for_doc
      );
      setDocumentWithCommunity(documentWithCommunity);
    }
  }, [Alldoc, community_id_for_doc, refetch, modalShow, page, pageSize, search]);

  console.log("documentWithCommunity---->>>>", documentWithCommunity)
  console.log("Alldoc---->>>>", Alldoc)

  useEffect(() => {
    if (docTypes?.length > 0) {
      const privatetypeId =
        docTypes?.find((type) => type.name === "private")?.id || null;

      setPrivatetypeId(privatetypeId);

      const publictypeId =
        docTypes?.find((type) => type.name === "public")?.id || null;

      setPublictypeId(publictypeId);
    }
  }, [docTypes]);

  const handleDocTypeChange = (e) => {
    const docTypeValue = e.target.value;
    setSelectedDocType(docTypeValue);

    if (docTypeValue == "public") { setSelectedFiles([]); setFileName("") }
    if (docTypeValue == "private") { setSelectedFiles([]); setFileName("") }

    const doc_type_sel =
      docTypeValue === "private"
        ? privatetypeId
        : docTypeValue === "public"
          ? publictypeId
          : null;

    setFormData((prevState) => ({
      ...prevState,
      doc_type: doc_type_sel,
      doc_type_name: "",
    }));
  };

  const handleDocTypeNameChange = (e) => {
    const selectedDocNameType = e.target.value;
    setFormData((prevState) => ({
      ...prevState,
      doc_type_name: selectedDocNameType,
    }));
  };

  // const handleFileChange = (e) => {
  //   const files = Array.from(e.target.files); // Convert FileList to an array
  //   setSelectedFiles(files); // Update the state with selected files
  //   setFileName(files.map((file) => file.name).join(", ")); // Optional: Display file names
  //   setFormData((prevState) => ({
  //     ...prevState,
  //     community_documents: files, // Store the array of files
  //   }));
  // };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files); // Convert FileList to an array
    const allowedExtensions = [".pdf", ".doc", ".docx", ".xlsx", ".csv"];
    // Filter valid files
    const validFiles = files.filter((file) => {
      const fileExtension = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      return allowedExtensions.includes(fileExtension);
    });

    if (validFiles.length === 0) {
      setError("Invalid file type. Please select a valid file.");
      return; // Stop execution if no valid file is selected
    }

    setError("");

    if (selectedDocType === "private") {
      // For "private", append the new files
      setSelectedFiles((prevSelectedFiles) => [...prevSelectedFiles, ...validFiles]);

      setFileName((prevFileNames) => {
        const newFileNames = validFiles.map((file) => file.name);
        return [...prevFileNames.split(", "), ...newFileNames].join(", ");
      });

      setFormData((prevState) => ({
        ...prevState,
        community_documents: [
          ...(Array.isArray(prevState.community_documents) ? prevState.community_documents : []),
          ...validFiles,
        ],
      }));
    }
    if (selectedDocType === "public") {
      // For non-"private", replace with the first selected file
      // const newFile = files[0]; // Get the first file

      // setSelectedFiles(newFile); // Replace with the newly selected file
      // setFileName(newFile.name); // Set the file name directly (single file)

      // setFormData((prevState) => ({
      //   ...prevState,
      //   community_documents: newFile, // Replace with the new file
      // }));
      setSelectedFiles(validFiles);
      setFileName(validFiles.map((file) => file.name).join(", "));
      setFormData((prevState) => ({
        ...prevState,
        community_documents: validFiles,
      }));
    }
  };

  const handleFileRemove = (fileToRemove) => {
    setSelectedFiles((prevSelectedFiles) => {
      const updatedFiles = prevSelectedFiles.filter((file) => file.name !== fileToRemove.name);

      // Update state
      setFileName(updatedFiles.map((file) => file.name).join(", "));
      setFormData((prevState) => ({
        ...prevState,
        community_documents: updatedFiles,
      }));

      // Reset the file input if no files remain
      if (updatedFiles.length === 0) {
        document.getElementById("upload-file").value = ""; // Reset input field
      }

      return updatedFiles;
    });
  };


  useEffect(() => {
    const isFormValid = () => {
      return (
        formData.doc_type &&
        (selectedDocType !== "public" || formData.doc_type_name) &&
        selectedFiles.length > 0
      );
    };

    setDisabled(!isFormValid());
  }, [formData, selectedFiles, selectedDocType]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (disabled) return; // Prevent submission if the form is invalid.

    const finaldata = new FormData();
    finaldata.append("doc_type", formData.doc_type);
    if (selectedDocType === "public") {
      finaldata.append("doc_type_name", formData.doc_type_name);
    }
    selectedFiles.forEach((file) => finaldata.append("community_documents", file));
    finaldata.append("community_id", community_id_for_doc);
    finaldata.append("user_id", userId);

    dispatch(uploadDocuments(finaldata))
      .unwrap()
      .then((res) => {
        if (selectedDocType === "public") toast.success("Document uploaded successfully!");
        if (selectedDocType === "private") toast.warning("Document processing!");
        setDocumentData(res.data);
        setTaskId(res.data.task_id)
        setFormData({
          community_id: "",
          doc_type: "",
          doc_type_name: "",
          community_documents: null,
        });
        setFileName("");
        setSelectedFiles([]);
        setSelectedDocType("")
      })
      .catch((err) => {
        toast.error("Document upload failed!");
      });
  };

  const confirmDelete = async () => {
    setModalOpen(false);
    try {
      await dispatch(deleteDocumentData(currentId)).unwrap();
      toast.success("document deleted successfully");
      dispatch(getAllDocuments())
        .unwrap()
        .then((res) => {
          setAllDoc(res);
          setLoading(false);
        })
        .catch((err) => {
          console.error("Error fetching documents after delete:", err);
          toast.error("Failed to refresh document list.");
        });
    } catch (error) {
      console.error("Error deleting community:", error);
      toast.error("Failed to delete community");
    }
  };

  const handleGetByIdDocument = async (id, e) => {
    try {
      const response = await dispatch(fetchDocumentById(id)).unwrap();
      const documentUrl = response?.data?.community_documents;

      if (documentUrl) {
        window.open(documentUrl, "_blank"); // Opens the URL in a new tab
      } else {
        toast.error("Document URL not found.");
      }
    } catch (error) {
      console.error("Error fetching document:", error);
      toast.error("Failed to fetch document.");
    }
  };

  const handleDeleteModel = (id) => {
    setcurrentId(id);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <>
      <div className="back-btn">
        <button onClick={() => navigate(-1)} className="back-btn-button">
          {/* <img src={chevronleft} alt="chevron-left" className="left-icon" />
           */}
          <ArrowBackIcon className="left-icon" />
          Back
        </button>
      </div>
      <div
        className="modal fade"
        id="deleteDocumentModal"
        tabIndex="-1"
        aria-labelledby="addCommunityModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="addCommunityModalLabel">
                Delete Document
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeModal}
              ></button>
            </div>
            <div className="modal-body">
              <label htmlFor="communitySelect" className="form-label">
                Are you sure you want to delete Document
              </label>
            </div>
            <div className="modal-footer community-footer">
              <button
                type="button"
                className="bttn-close"
                data-bs-dismiss="modal"
                onClick={closeModal}
              >
                Close
              </button>
              <button
                type="button"
                className="bttn-upload"
                data-bs-dismiss="modal"
                onClick={confirmDelete}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="community-section">
        <div className="community-inner-wrap">
          <div className="add-new-community d-flex justify-content-between align-items-center">
            {/* <div className="community-heading create-new">
              Upload Community Documents
            </div> */}
            <div className="community-heading create-new">
              {capitalizeWords(community_name)}
            </div>
          </div>
          <div className="create-community-name-table">
            <div className="create-comm-inner-wrap">
              <div className="upload-docs-block">
                <div className="upload-docs-title">Upload Documents</div>
                <form>
                  <div className="mb-4 d-flex file-name-docs-block mt-4 align-items-center ">
                    <div className="doc_type_label child-div">
                      <InputLabel htmlFor="doc_type">Document Type</InputLabel>
                      <div className="radio-group-block d-flex gap-3">
                        <label className="custom-radio ">
                          <input
                            type="radio"
                            id="public"
                            value="public"
                            checked={formData.doc_type === publictypeId}
                            onChange={handleDocTypeChange}
                          />
                          <span className="checkmark-radio"></span>
                          Public
                        </label>
                        <label className="custom-radio ">
                          <input
                            type="radio"
                            id="private"
                            value="private"
                            checked={formData.doc_type === privatetypeId}
                            onChange={handleDocTypeChange}
                          />
                          <span className="checkmark-radio"></span>
                          Private
                        </label>
                      </div>

                    </div>
                    {selectedDocType === "public" && (<div className="comm-name-blk child-div">
                      <InputLabel htmlFor="doc_type_name_id">
                        Document Name
                      </InputLabel>

                      <select
                        id={`doc_type_name_id`}
                        name="doc_type_name_id"
                        className="dropdown-box"
                        disabled={selectedDocType === "private" || selectedDocType == ""}
                        value={formData.doc_type_name} // Ensure value is properly controlled
                        onChange={handleDocTypeNameChange}

                      >
                        <option value="" disabled>
                          Select Document Name
                        </option>

                        {data?.data?.map((data) => (
                          <option key={data.id} value={data.id}>
                            {data.name}
                          </option>
                        )) || null}
                      </select>
                      {errors.doc_type_name_id && (
                        <div className="error-text">
                          {errors.doc_type_name_id}
                        </div>
                      )}
                    </div>)}

                  </div>
                  <div className="mb-4 d-flex file-name-docs-block mt-4 align-items-center ">
                    <div className="d-flex file-name-docs-upload-doc child-div">
                      <div className="">
                        <div class="upload-document">
                          <label for="upload-file up-docs">
                            {selectedDocType === "private" ? "Upload Bulk Document" : "Upload Document"}
                          </label>
                          <div class="file-input-container">
                            <input
                              type="file"
                              id="upload-file"
                              name="upload-file"
                              onChange={handleFileChange}
                              accept=".pdf,.doc,.docx,.xlsx,.csv"
                              // accept=".pdf"
                              disabled={selectedDocType === ""}
                              multiple={selectedDocType === "private"}
                            />
                            <label
                              for="upload-file"
                              className="file-upload-label up-docs"
                            >
                              <span class="attachment-icon">
                                <svg
                                  width="24"
                                  height="20"
                                  viewBox="0 0 24 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M6.73897 19.95C5.60156 19.9503 4.48961 19.6133 3.54382 18.9815C2.59803 18.3496 1.86091 17.4515 1.42572 16.4006C0.99054 15.3498 0.876853 14.1934 1.09905 13.0779C1.32124 11.9624 1.86934 10.9379 2.67397 10.134L11.159 1.648C11.2997 1.5073 11.4905 1.42826 11.6895 1.42826C11.8884 1.42826 12.0793 1.5073 12.22 1.648C12.3607 1.78869 12.4397 1.97952 12.4397 2.1785C12.4397 2.37747 12.3607 2.5683 12.22 2.709L3.73397 11.194C3.32314 11.585 2.99471 12.0542 2.76804 12.5741C2.54136 13.0939 2.42103 13.6539 2.41412 14.221C2.40721 14.788 2.51387 15.3508 2.72782 15.876C2.94176 16.4012 3.25866 16.8783 3.65985 17.2792C4.06104 17.68 4.53839 17.9965 5.0638 18.21C5.5892 18.4236 6.15202 18.5297 6.7191 18.5224C7.28618 18.515 7.84605 18.3942 8.36572 18.1671C8.88539 17.94 9.35435 17.6112 9.74497 17.2L20.705 6.24C21.2072 5.72136 21.4854 5.02608 21.4797 4.30414C21.4739 3.58221 21.1845 2.89148 20.674 2.38098C20.1635 1.87048 19.4728 1.58111 18.7508 1.57532C18.0289 1.56952 17.3336 1.84776 16.815 2.35L7.97697 11.194C7.86088 11.3101 7.7688 11.4479 7.70597 11.5996C7.64314 11.7513 7.61081 11.9138 7.61081 12.078C7.61081 12.2422 7.64314 12.4047 7.70597 12.5564C7.7688 12.7081 7.86088 12.8459 7.97697 12.962C8.09306 13.0781 8.23088 13.1702 8.38255 13.233C8.53423 13.2958 8.6968 13.3282 8.86097 13.3282C9.02514 13.3282 9.18771 13.2958 9.33939 13.233C9.49107 13.1702 9.62888 13.0781 9.74497 12.962L15.4 7.306C15.4691 7.23433 15.5519 7.17716 15.6433 7.13781C15.7348 7.09846 15.8332 7.07772 15.9328 7.07681C16.0324 7.0759 16.1312 7.09483 16.2234 7.1325C16.3155 7.17016 16.3993 7.22581 16.4698 7.2962C16.5402 7.36659 16.5959 7.4503 16.6337 7.54245C16.6714 7.63461 16.6905 7.73336 16.6897 7.83294C16.6888 7.93253 16.6682 8.03095 16.6289 8.12247C16.5897 8.21399 16.5326 8.29678 16.461 8.366L10.805 14.023C10.5496 14.2784 10.2465 14.481 9.91279 14.6193C9.57913 14.7576 9.2215 14.8287 8.86032 14.8288C8.49915 14.8288 8.14151 14.7577 7.80781 14.6196C7.47411 14.4814 7.17089 14.2789 6.91547 14.0235C6.66005 13.7681 6.45743 13.465 6.31917 13.1313C6.18091 12.7977 6.10973 12.44 6.10968 12.0789C6.10959 11.3494 6.39926 10.6498 6.91497 10.134L15.755 1.3C16.5519 0.502889 17.6329 0.0550254 18.7601 0.0549317C19.8873 0.0548379 20.9684 0.502521 21.7655 1.2995C22.5626 2.09647 23.0104 3.17746 23.0105 4.30464C23.0106 5.43183 22.5629 6.51289 21.766 7.31L10.806 18.266C10.273 18.8016 9.6392 19.2262 8.94111 19.5153C8.24302 19.8043 7.49454 19.9521 6.73897 19.95Z"
                                    fill="#414141"
                                  />
                                </svg>
                              </span>{" "}
                              <span className="add-attachment-text">
                                {selectedDocType === "private" ? "Add attachments" : "Add attachment"}
                              </span>
                            </label>
                            {errors.community_documents && (
                              <div className="error-text">
                                {errors.community_documents}
                              </div>
                            )}
                            {/* Show file name after uploading */}
                            {/* {fileName && (
                              <div className="mt-2 file-name">{fileName}</div>
                            )} */}
                            {(fileName && selectedDocType == "public") && fileName.split(",").map((file, index) => (
                              <div key={index} className="mt-2 file-name">{file}</div>
                            ))}
                            {selectedDocType === "private" && selectedFiles.length > 0 && (
                              <div>
                                <ul className="private-public-folder">
                                  {selectedFiles.map((file, index) => (
                                    <li key={index}>
                                      {file.name} {" "}
                                      <button title="Remove File
                                      " type="button" onClick={() => handleFileRemove(file)} style={{
                                          all: 'unset',
                                          cursor: 'pointer',
                                        }}><RemoveCircleOutlineOutlinedIcon sx={{ color: "#e55426" }} /></button>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            )}
                          </div>
                        </div>
                        {error && <div className="text-danger">{error}</div>}
                      </div>
                      {/* <div className=""></div> */}
                    </div>

                  </div>
                  {selectedFiles.length > 0 && (<div className="d-flex gap-3 add-minus-btns child-div justify-content-center">
                    <div className="add-btn-field">
                      <div class="d-grid gap-2  ">
                        <button
                          className="btn add-btn-form text-center"
                          onClick={handleSubmit}
                          disabled={disabled}
                        >
                          Upload
                        </button>
                      </div>
                    </div>
                  </div>)}

                </form>

                {/* ))} */}
                {uloading ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      minHeight: "10vh",
                      flexDirection: "column",
                      textAlign: "center",
                      marginTop: "10px"
                    }}
                  >
                    <CircularProgress size={50} sx={{ color: "#e55426" }} />
                    <h5 style={{ color: "#414141" }}>Uploading...</h5>
                  </Box>
                ) : (
                  <></>
                )}
              </div>

            </div>
            <p className="doc-type-info mt-2">
              {selectedDocType === "private" ? (
                <>
                  <b>Note:</b> You can upload multiple files without selecting a document name.
                </>
              ) : selectedDocType === "public" ? (
                <>
                  <b>Note:</b> Please select a document name when uploading a public document.
                </>
              ) : (
                <></>
              )}
            </p>

            {/* <div className="create-comm-btn">
                <button
                  type="submit"
                  className="orange-filled-btn"
                  onClick={handleSubmit}
                >
                  Submit Documents
                </button>
              </div> */}
          </div>
          <div className="create-comm-inner-wrap mt-5 upload-docs-table">
            {loading ? (
              <>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "25vh",
                    flexDirection: "column",
                    textAlign: "center",
                  }}
                >
                  <CircularProgress size={50} sx={{ color: "#e55426" }} />
                </Box>
              </>
            ) : (<>
              <div className="title-search-block d-flex justify-content-between align-items-center">
                <div className="allcommunities mt-4 mx-4">Uploaded Documents</div>
                <div className="searchbar mt-4 mx-4">
                  <input
                    type="search"
                    placeholder="Search..."
                    className="inputsearch"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
              </div>
              <div className="upload-docs-block">
                <table className="table">
                  <thead>
                    <tr>
                      <th>
                        <a href="">Document Name</a>
                      </th>
                      <th>
                        <a href="">Document Type</a>
                      </th>
                      <th>
                        <a href="">Document Type Name</a>
                      </th>
                      <th>
                        <a href="">Action</a>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {documentWithCommunity?.map((data, index) => (
                      <tr key={data.id}>
                        <td>
                          <div className="d-flex justify-content-between">
                            {data?.document_name}
                            {/* <button
                              style={{
                                all: "unset",
                                background: "none",
                                border: "none",
                                padding: "0",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                setFileNameToEdit(data?.document_name);
                                setDocumentIdForEdit(data?.id)
                                setModalShow(true);
                              }}
                            >
                              <Tooltip title="File Rename">
                                <DriveFileRenameOutlineIcon fontSize="small" />
                              </Tooltip>

                            </button> */}
                          </div>
                        </td>
                        <td>{capitalizeWords(data.doc_type_display)}</td>
                        <td>{data.doc_type_name_display}</td>
                        <td>
                          <div className="d-flex gap-2">
                            <a title="Edit" style={{ cursor: "pointer" }}>
                              <div
                                className="edit"
                                onClick={() => {
                                  setFileNameToEdit(data?.document_name);
                                  setDocumentIdForEdit(data?.id)
                                  setModalShow(true);
                                }}
                              // onClick={() => {
                              //   navigate("/admin/update-document", {
                              // state: {
                              //   document_id: data.id,
                              //   community_id: data.community_id, // Passing community_id
                              // },
                              //   });
                              // }}
                              // onClick={() => {
                              //   if (userType === SuperAdmin) {
                              //     navigate("/super-admin/update-document", {
                              //       state: {
                              //         document_id: data.id,
                              //         community_id: data.community_id, // Passing community_id
                              //       },
                              //     });
                              //   } else if (userType === CommunityOwner) {
                              //     navigate("/admin/update-document", {
                              //       state: {
                              //         document_id: data.id,
                              //         community_id: data.community_id, // Passing community_id
                              //       },
                              //     });
                              //   }
                              // }}
                              >
                                <svg
                                  width="14"
                                  height="14"
                                  viewBox="0 0 13 14"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g clip-path="url(#clip0_101_3493)">
                                    <path
                                      d="M11.9985 8.63379C11.8196 8.63379 11.6747 8.77871 11.6747 8.95756V11.8323C11.6741 12.3685 11.2396 12.803 10.7034 12.8036H1.61884C1.08258 12.803 0.648182 12.3685 0.647534 11.8323V3.3952C0.648182 2.85908 1.08261 2.42455 1.61884 2.4239H4.49357C4.67238 2.4239 4.81733 2.27895 4.81733 2.10013C4.81733 1.92141 4.67238 1.77637 4.49357 1.77637H1.61884C0.725174 1.77737 0.00100368 2.50154 0 3.3952V11.8324C0.00100368 12.726 0.725174 13.4502 1.61884 13.4512H10.7034C11.5971 13.4502 12.3213 12.726 12.3223 11.8324V8.95756C12.3223 8.77871 12.1773 8.63379 11.9985 8.63379Z"
                                      fill="#414141"
                                    />
                                    <path
                                      d="M12.1943 0.943343C11.6253 0.374354 10.7028 0.374354 10.1338 0.943343L4.35758 6.71958C4.31804 6.75911 4.28942 6.80821 4.2745 6.8621L3.51491 9.60441C3.49958 9.65962 3.49918 9.71792 3.51376 9.77334C3.52834 9.82875 3.55736 9.87931 3.59788 9.91983C3.63839 9.96036 3.68893 9.9894 3.74435 10.004C3.79976 10.0186 3.85806 10.0182 3.91327 10.0029L6.65558 9.24318C6.70947 9.22826 6.75857 9.19964 6.79811 9.1601L12.5742 3.38377C13.1423 2.81436 13.1423 1.89266 12.5742 1.32328L12.1943 0.943343ZM5.06304 6.93003L9.79046 2.20251L11.3151 3.72713L6.58756 8.45465L5.06304 6.93003ZM4.7585 7.54114L5.97651 8.75931L4.29169 9.22612L4.7585 7.54114ZM12.1164 2.92593L11.773 3.26925L10.2483 1.74451L10.5918 1.40115C10.9078 1.08509 11.4203 1.08509 11.7363 1.40115L12.1164 1.78106C12.4319 2.09751 12.4319 2.60961 12.1164 2.92593Z"
                                      fill="#414141"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_101_3493">
                                      <rect
                                        width="13"
                                        height="13"
                                        fill="white"
                                        transform="translate(0 0.5)"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </div>
                            </a>
                            <a title="View" style={{ cursor: "pointer" }}>
                              <div
                                className="view-icon-eye"
                                onClick={() => handleGetByIdDocument(data.id)}
                              >
                                <svg
                                  width="15"
                                  height="14"
                                  viewBox="0 0 23 14"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M11.2772 7.20095L11.2775 7.20124C11.3939 7.3299 11.5511 7.37848 11.6814 7.39721C11.8148 7.41637 11.9605 7.41017 12.1008 7.39443C12.3541 7.36601 12.647 7.29888 12.913 7.23793C12.9403 7.23166 12.9674 7.22546 12.9941 7.21937C13.2974 7.15023 13.5476 7.09773 13.7196 7.09394C13.7326 7.09365 13.7442 7.09369 13.7544 7.09395C13.7039 8.25914 12.7191 9.20018 11.5 9.20018C10.2472 9.20018 9.24355 8.20822 9.24355 7C9.24355 5.80607 10.2236 4.82332 11.4557 4.80024C11.4558 4.80514 11.4559 4.81046 11.4558 4.81623C11.4552 4.96226 11.401 5.18477 11.3211 5.47591C11.3128 5.50623 11.3042 5.53716 11.2955 5.56858C11.2267 5.81731 11.1493 6.09697 11.1129 6.34728C11.0922 6.48979 11.082 6.63906 11.0991 6.77985C11.1162 6.92086 11.1636 7.07498 11.2772 7.20095ZM0.3 7C0.3 6.99221 0.303779 6.95415 0.330103 6.87721C0.354936 6.80463 0.394591 6.71243 0.451398 6.60209C0.564888 6.38165 0.7391 6.10377 0.975787 5.78837C1.44872 5.15817 2.16041 4.3924 3.10559 3.65187C4.99442 2.17201 7.80594 0.8 11.5 0.8C15.1935 0.8 18.005 2.172 19.894 3.65187C20.8392 4.39241 21.551 5.15819 22.0241 5.78839C22.2608 6.10379 22.4351 6.38167 22.5486 6.60211C22.6054 6.71245 22.6451 6.80466 22.6699 6.87724C22.6962 6.95417 22.7 6.99222 22.7 7C22.7 7.00045 22.7 6.99965 22.7 7.00016C22.7 7.00069 22.7 7.00003 22.7 7.00063L22.6999 7.00247L22.6992 7.00951C22.6985 7.01572 22.6971 7.02421 22.6948 7.03514C22.6902 7.05728 22.6823 7.0862 22.6699 7.12227C22.6451 7.19475 22.6054 7.28687 22.5486 7.39715C22.4351 7.61745 22.2608 7.89525 22.0241 8.21061C21.551 8.84073 20.8392 9.60659 19.894 10.3473C18.005 11.8274 15.1934 13.2 11.5 13.2C7.80598 13.2 4.99446 11.8274 3.10561 10.3473C2.16042 9.6066 1.44872 8.84074 0.975773 8.21063C0.739078 7.89528 0.564857 7.61748 0.451361 7.39717C0.39455 7.2869 0.354896 7.19478 0.330067 7.1223C0.31771 7.08622 0.309813 7.0573 0.305159 7.03515C0.30286 7.02422 0.301521 7.01574 0.300779 7.00952L0.300108 7.00248L0.300014 7.00063C0.299992 7.00003 0.300008 7.00069 0.300002 7.00016C0.29999 6.99965 0.299997 7.00045 0.3 7ZM6.08825 7C6.08825 9.9333 8.51741 12.2992 11.5 12.2992C14.4827 12.2992 16.9106 9.93321 16.9106 7C16.9106 4.06697 14.4829 1.69848 11.5 1.69848C8.51722 1.69848 6.08825 4.06688 6.08825 7Z"
                                    stroke="#414141"
                                    stroke-width="0.6"
                                  />
                                </svg>
                              </div>
                            </a>
                            <a title="Delete" style={{ cursor: "pointer" }}>
                              <div
                                className="dustbin-icon"
                                data-bs-toggle="modal"
                                data-bs-target="#deleteDocumentModal"
                                onClick={() => handleDeleteModel(data.id)}
                              >
                                <svg
                                  width="14"
                                  height="14"
                                  viewBox="0 0 13 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M11.7296 2.35905H9.65408V2.06273C9.65408 1.36769 9.08864 0.802246 8.3936 0.802246H4.6064C3.91136 0.802246 3.34592 1.36769 3.34592 2.06273V2.35905H1.2704C1.00895 2.35934 0.758291 2.46332 0.573404 2.64818C0.388517 2.83304 0.284496 3.08368 0.284157 3.34513V3.81265C0.284157 4.32161 0.671837 4.74161 1.1672 4.79345L2.18272 13.7048C2.27952 14.5558 2.99872 15.1976 3.85536 15.1976H9.14448C10.0011 15.1976 10.7203 14.5558 10.8171 13.7048L11.8326 4.79345C12.0749 4.76767 12.2991 4.65326 12.4621 4.47222C12.6251 4.29117 12.7154 4.05626 12.7157 3.81265V3.34513C12.7153 3.08368 12.6113 2.83304 12.4264 2.64818C12.2415 2.46332 11.991 2.35934 11.7296 2.35905ZM3.98608 2.06273C3.98625 1.89822 4.05167 1.74049 4.168 1.62417C4.28432 1.50784 4.44205 1.44242 4.60656 1.44225H8.39376C8.55827 1.44242 8.71599 1.50784 8.83231 1.62417C8.94864 1.74049 9.01407 1.89822 9.01424 2.06273V2.35905H3.98608V2.06273ZM10.1814 13.6323C10.1526 13.887 10.0309 14.1221 9.8397 14.2928C9.64848 14.4635 9.4011 14.5577 9.1448 14.5576H3.85568C3.59937 14.5577 3.35199 14.4635 3.16078 14.2928C2.96956 14.1221 2.8479 13.887 2.81904 13.6323L1.81248 4.79889H11.1882L10.1814 13.6323ZM12.076 3.81265C12.0759 3.90444 12.0393 3.99243 11.9744 4.05733C11.9095 4.12224 11.8215 4.15876 11.7298 4.15889H1.2704C1.17861 4.15876 1.09061 4.12224 1.02571 4.05733C0.960803 3.99243 0.924284 3.90444 0.924157 3.81265V3.34513C0.924157 3.15441 1.07952 2.99905 1.2704 2.99905H11.7294C11.9203 2.99905 12.0757 3.15441 12.0757 3.34513V3.81265H12.076Z"
                                    fill="#414141"
                                  />
                                  <path
                                    d="M6.5 12.8257C6.58487 12.8257 6.66626 12.792 6.72627 12.732C6.78628 12.672 6.82 12.5906 6.82 12.5057V6.85101C6.82 6.76614 6.78628 6.68474 6.72627 6.62473C6.66626 6.56472 6.58487 6.53101 6.5 6.53101C6.41513 6.53101 6.33373 6.56472 6.27372 6.62473C6.21371 6.68474 6.18 6.76614 6.18 6.85101V12.5057C6.18 12.5906 6.21371 12.672 6.27372 12.732C6.33373 12.792 6.41513 12.8257 6.5 12.8257ZM8.41296 12.8108C8.45478 12.815 8.49699 12.8108 8.5372 12.7986C8.5774 12.7863 8.6148 12.7663 8.64725 12.7396C8.67971 12.7129 8.70658 12.6801 8.72634 12.643C8.7461 12.6059 8.75835 12.5653 8.7624 12.5235L9.31056 6.89533C9.31881 6.81086 9.29317 6.72658 9.23928 6.66101C9.18539 6.59545 9.10766 6.55398 9.0232 6.54573C8.98132 6.54136 8.939 6.54535 8.89868 6.55747C8.85836 6.56959 8.82085 6.5896 8.78833 6.61633C8.75581 6.64306 8.72892 6.67599 8.70922 6.7132C8.68953 6.75041 8.67742 6.79116 8.6736 6.83309L8.12544 12.4612C8.11718 12.5457 8.14282 12.63 8.19671 12.6956C8.2506 12.7611 8.32849 12.8026 8.41296 12.8108ZM4.55568 12.8124C4.60035 12.8125 4.64454 12.8032 4.68539 12.7851C4.72625 12.767 4.76287 12.7406 4.79289 12.7075C4.82291 12.6744 4.84567 12.6354 4.85971 12.593C4.87375 12.5506 4.87875 12.5057 4.8744 12.4612L4.32624 6.83309C4.3224 6.79117 4.31027 6.75043 4.29057 6.71323C4.27087 6.67603 4.24398 6.64311 4.21146 6.61638C4.17894 6.58965 4.14144 6.56964 4.10113 6.55751C4.06082 6.54539 4.01851 6.54138 3.97664 6.54573C3.89217 6.55398 3.81444 6.59545 3.76055 6.66101C3.70666 6.72658 3.68102 6.81086 3.68928 6.89533L4.23744 12.5235C4.24514 12.6025 4.28197 12.6759 4.34076 12.7293C4.39954 12.7827 4.47625 12.8123 4.55568 12.8124Z"
                                    fill="#414141"
                                  />
                                </svg>
                              </div>
                            </a>
                          </div>
                        </td>
                      </tr>

                    ))}
                    {documentWithCommunity.length === 0 && (<tr><td colSpan="6">No Documents Uploaded</td></tr>)}
                  </tbody>
                </table>
                <PaginationComponent
                  count={count}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  page={page}
                  setPage={setPage}
                />
              </div>

            </>
            )}

          </div>
        </div>
      </div>
      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        fileNameToEdit={fileNameToEdit}
        documentIdForEdit={documentIdForEdit}
        refetch={() => setRefetch(true)}
      />
      <ToastContainer />
    </>
  );
};

function MyVerticallyCenteredModal(props) {
  // console.log("props", props)
  const [fileName, setFileName] = useState(props.fileNameToEdit);
  const [documentId, setDocumentId] = useState(props.documentIdForEdit)
  const dispatch = useDispatch()

  useEffect(() => {
    if (props.fileNameToEdit) {
      setFileName(props.fileNameToEdit);
    }
    if (props.documentIdForEdit) {
      setDocumentId(props.documentIdForEdit)
    }
  }, [props])
  const handleFileNameChange = (e) => {
    setFileName(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await dispatch(updateDocumentNameApi({
        document_id: documentId,
        document_name: fileName
      })).unwrap().then(() => {
        props.refetch();
        toast.success("Document renamed successfully");
        dispatch(getAllDocuments())
          .unwrap()
      }).finally(() => { props.onHide() })
    } catch (error) {
      console.error("Error renaming document:", error);
      toast.error("Failed to rename document");
    }
  };

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Edit File Name
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* <h4>Enter the file name</h4> */}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="fileName">File Name:</label>
            <input
              type="text"
              id="fileName"
              className="form-control"
              value={fileName}
              onChange={handleFileNameChange}
              required
            />
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button onClick={props.onHide} className="bttn-close">Close</button>
        <button onClick={handleSubmit} className="bttn-upload">Submit</button>
      </Modal.Footer>
    </Modal>
  );
}

export default UploadDocument;
